// extracted by mini-css-extract-plugin
module.exports = {"filter--slider":"filters_filter--slider__3Zvui","filter--slider-min-max":"filters_filter--slider-min-max__1FQT5"};